export enum ProgressStatusAppearance {
  ICON = 'icon',
  /** @deprecated: Use STATUS_CARD_IMAGE instead. Will be removed in future versions. */
  STATUS_CARD_IMAGE = 'status-up-image',
  LION_CARD_MOV = 'lion-card-animation-mov',
  LION_CARD_WEBM = 'lion-card-animation-webm',
  STATUS_CARD_FRAME = 'status-up-frame',
}
